import { Center, Loader } from "@mantine/core";
import { formatNZD, formatPercent } from "common/utils";

import { safeApiCall } from "api/common.service";
import { getGrossProfitMargins } from "api/report.service";
import { MAX_PAGE_SIZE } from "common/constants";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptGrossProfitMarginSummaries } from "types/model.types";

const PrintGrossProfitMarginPreview: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<RptGrossProfitMarginSummaries>([]);

  const [params] = useSearchParams();
  const startCode = params.get("f");
  const endCode = params.get("t");

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const from: number | null = startCode ? Number(startCode) : null;
        const to: number | null = endCode ? Number(endCode) : null;

        const result = await safeApiCall(
          getGrossProfitMargins(from, to, MAX_PAGE_SIZE, 1),
        );

        if (mounted && result) setData(result?.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <div className="sub-title">Gross Profit Margins</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>GP 1</th>
            <th>GP 2</th>
            <th>GP 3</th>
            <th>GP 4</th>
            <th>Sell Price 1</th>
            <th>Sell Price 2</th>
            <th>Sell Price 3</th>
            <th>Sell Price 4</th>
            <th>Retail</th>
            <th>Cost Price</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={11}>
                <Center>
                  <Loader />
                </Center>
              </td>
            </tr>
          ) : (
            data.map((row, index) => (
              <tr key={`${index}-${row.id}`}>
                <td>{row.id}</td>
                <td>{formatPercent(row.gp1, 0, false)}</td>
                <td>{formatPercent(row.gp2, 0, false)}</td>
                <td>{formatPercent(row.gp3, 0, false)}</td>
                <td>{formatPercent(row.gp4, 0, false)}</td>
                <td>{formatNZD(row.sellPrice1)}</td>
                <td>{formatNZD(row.sellPrice2)}</td>
                <td>{formatNZD(row.sellPrice3)}</td>
                <td>{formatNZD(row.sellPrice4)}</td>
                <td>{formatNZD(row.retail)}</td>
                <td>{formatNZD(row.costPrice)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </>
  );
};

export default PrintGrossProfitMarginPreview;
